import { iBrand } from "@sdk/brands/brand-model";
import { iStore } from "../../store.model";
import { CreateSelectorForEntities } from "../../utils/entity-slice-creator";

export const {
  selectQueryMap: selectBrandQueryMap,
  selectEntityMap: selectBrandsMap,
  selectQueryMapAll: selectBrandsMapAll,
  selectQueryAllList: selectBrandsAllList,
  selectAllEntities: selectAllBrands,
  selectAllEntitiesQuery: selectAllBrandsQuery,
  selectEntityById: selectBrandById,
  selectEntityQuery: selectBrandQuery,
  selectEntityQueryList: selectBrandQueryList,
} = CreateSelectorForEntities<iStore, iBrand>({
  sliceName: "brands",
});
